"use strict";

const metrikaId = (() => {
  let mt = document.querySelector('meta[name="ymetrika"]');
  return mt && mt.getAttribute("content")
    ? mt.getAttribute("content")
    : 53131834;
})();

class Metrika {
  constructor() {
    this.id = 0;
    this.ym = void 0;
    this.defferedTimer = void 0;
    this.deferredList = [];
    this.init();
  }

  /**
   * Инициализация этого объекта.
   * Сама Я.Метрика `ym` уже должна присутствовать в объекте `window`.
   * Иначе будет использована отложенная инициализация.
   *
   * @param {object} [options]
   * @returns {this}
   * @public
   */
  init(options = {}) {
    if (this.ym) {
      return this;
    }
    if (!window.ym) {
      return this._defferedInit(options);
    }

    this.initClickers();

    return this._init(options);
  }

  _init(options) {
    this.id = options.id || metrikaId;
    this.ym = window.ym;
    return this;
  }

  /**
   * Отложенная инициализация.
   *
   * @param {object} [options]
   * @returns {this}
   */
  _defferedInit(options) {
    this.initClickers();

    this.defferedTimer = setInterval(() => {
      if (!window.ym) {
        return;
      }

      this._init(options)._runDeferredList();

      clearInterval(this.defferedTimer);
    }, 1000);
    return this;
  }

  /**
   * Запуск и очистка списка отложенных событий
   *
   * @returns {this}
   */
  _runDeferredList() {
    if (!this.deferredList.length) {
      return this;
    }

    this.deferredList.forEach(item => {
      switch (item.type) {
        case "goal":
          this.goal(item.name, item.params);
          break;
        case "hit":
          this.hit(item.url);
          break;
      }
    });
    this.deferredList.splice(0, this.deferredList.length);
    return this;
  }

  /**
   *
   * Инициализация отслеживания кликов
   * по элементам с аттрибутом `data-goal`.
   * Где значение аттрибутов:
   *  `data-goal`        - имя цели,
   *  `data-goal-params` - json-объект с параметрами.
   *
   * @param {string} [selector]
   * @returns {this}
   * @public
   */
  initClickers(selector = "[data-goal],[data-pixel]") {
    document.addEventListener("click", e => {
      if (!e.target.closest) {
        //return console.warn(
        //  "This element not supports `closest`. Use polyfill."
        //);
      }
      let el = e.target.closest(selector);
      if (
        !el ||
        (!el.getAttribute("data-goal") && !el.getAttribute("data-pixel"))
      ) {
        return;
      }

      let pixel = el.getAttribute("data-pixel");
      if (pixel) {
        this.showPixel(pixel);
      }

      let name = el.getAttribute("data-goal");
      if (!name) {
        return;
      }

      let params = el.getAttribute("data-goal-params");
      if (params) {
        params = JSON.parse(params);
      }
      this.goal(name);
    });

    return this;
  }

  /**
   * Передача информации о достижении цели
   *
   * @param {string} name - Идентификатор цели
   * @param {object} [params] - Параметры цели
   * @returns {this}
   * @public
   */
  goal(name, params) {
    if (!this.ym) {
      this.deferredList.push({
        type: "goal",
        name,
        params
      });
      return this;
    }
    this.ym(this.id, "reachGoal", name, params);
    return this;
  }

  /**
   * Отправка данных о просмотре.
   * Обычно используется на страницах,
   * реализованных с использованием AJAX.
   *
   * @param {string} [url] - Урл страницы
   * @returns {this}
   * @public
   */
  hit(url) {
    if (!this.ym) {
      this.deferredList.push({
        type: "hit",
        url
      });
      return this;
    }
    this.ym(this.id, "hit", url ? url : window.location.pathname);
    return this;
  }

  /**
   * Программный показ трекингового пикселя.
   * Для странных задач, когда `goal` или `hit`,
   * вопреки логике, не подходит ПМ,
   * или когда совсем никак, а надо.
   *
   * @param {string} link - Урл пикселя
   * @returns {this}
   * @public
   */
  showPixel(link) {
    let img = document.createElement("img");
    img.className = "ad-pixel";
    img.style.position = "absolute";
    img.style.width = "1px";
    img.style.height = "1px";
    img.style.top = 0;
    img.src = this.randomizeLink(link);
    document.body.append(img);
    return this;
  }

  /**
   * Замена подстроки `%random%` на рандомное число.
   *
   * @param {string} link - Урл пикселя с подстрокой `%random%`
   * @returns {string}
   * @public
   */
  randomizeLink(link) {
    return link.replace(/%random%/g, this._random(100, 9999999));
  }

  _random(min, max) {
    let rand = min - 0.5 + Math.random() * (max - min + 1);
    return Math.round(rand);
  }
}

const metrika = new Metrika();

export { metrika, Metrika };
